import React from 'react'
import { Checkbox, Divider } from 'antd'
import { TableProps } from 'antd/lib/table'
import { useDispatch } from 'react-redux'

import { ColumnProps } from 'src/components/Ant/Table'
import { PropsTreeSelected } from 'src/views/Management/Administration/views/tree'
import { ResponseDataRequestsItem } from 'src/core/store/ducks/groupTrees/types'
import { sendGroupTrees } from 'src/core/store/ducks/groupTrees/actions'
import { Table, Text, Button } from 'src/components/Ant'
import { User, Id, RoleType } from 'src/types'
import { useT } from 'src/core/hooks/use-translation'
import StatusFilter from 'src/views/Requests/components/StatusFilter'
import UserAvatar from 'src/components/UserAvatar'

import * as CSS from './styles'

type PropsTableList = {
  filterRole?: string[]
  isModal?: boolean
  setFilterRole?: (filterRole: string[]) => void
  setVisibleModal?: (visibleModal: boolean) => void
  treesSelected?: PropsTreeSelected
  usersFiltered?: any
}

type SendRoleProps = {
  assign_tree_id: Id
  remove?: boolean
  role_type: RoleType
  user_id: Id
}

export default function TableList({
  filterRole,
  isModal = false,
  setFilterRole,
  setVisibleModal,
  treesSelected,
  usersFiltered,
  ...props
}: TableProps<any> & PropsTableList) {
  const { t } = useT()
  const dispatch = useDispatch()

  function sendRole({
    assign_tree_id,
    remove,
    role_type,
    user_id
  }: SendRoleProps) {
    dispatch(
      sendGroupTrees([{ assign_tree_id, user_id, role_type, delete: remove }])
    )
  }

  const columns: ColumnProps<ResponseDataRequestsItem>[] & ColumnProps<User>[] =
    [
      {
        dataIndex: '',
        key: '',
        render: (row: any) => {
          const { gender, name } = isModal
            ? Object.assign(row, { name: `${row.first_name + row.last_name}` })
            : row.user
          return (
            <CSS.ContainerAvatar>
              <UserAvatar gender={gender} name={name} size="large" />
              {name}
            </CSS.ContainerAvatar>
          )
        }
      },
      {
        align: 'center',
        dataIndex: 'role_type',
        key: 'approver',
        render: (role_type: RoleType, row: any) => (
          <CSS.ContainerCheckbox>
            <Checkbox
              checked={role_type?.includes('APPROVER')}
              onChange={e => {
                const role: SendRoleProps = {
                  assign_tree_id: isModal
                    ? treesSelected.id
                    : row.assign_tree_id,
                  user_id: row.user_id,
                  role_type: RoleType.APPROVER
                }
                if (e.target.checked) {
                  sendRole(role)
                  return
                }
                sendRole(Object.assign(role, { remove: true }))
              }}
            />
          </CSS.ContainerCheckbox>
        ),
        title: 'web.tree.table.approver'
      },
      {
        align: 'center',
        dataIndex: 'role_type',
        key: 'checker',
        render: (role_type: RoleType, row: any) => (
          <CSS.ContainerCheckbox>
            <Checkbox
              checked={role_type?.includes('CHECKER')}
              onChange={e => {
                const role: SendRoleProps = {
                  assign_tree_id: isModal
                    ? treesSelected.id
                    : row.assign_tree_id,
                  user_id: row.user_id,
                  role_type: RoleType.CHECKER
                }
                if (e.target.checked) {
                  sendRole(role)
                  return
                }
                sendRole(Object.assign(role, { remove: true }))
              }}
            />
          </CSS.ContainerCheckbox>
        ),
        title: 'web.tree.table.checker'
      },
      {
        align: 'center',
        dataIndex: 'role_type',
        key: 'controller',
        render: (role_type: RoleType, row: any) => (
          <CSS.ContainerCheckbox>
            <Checkbox
              checked={role_type?.includes('CONTROLLER')}
              onChange={e => {
                const role: SendRoleProps = {
                  assign_tree_id: isModal
                    ? treesSelected.id
                    : row.assign_tree_id,
                  role_type: RoleType.CONTROLLER,
                  user_id: row.user_id
                }

                if (e.target.checked) {
                  sendRole(role)
                  return
                }
                sendRole(Object.assign(role, { remove: true }))
              }}
            />
          </CSS.ContainerCheckbox>
        ),
        title: 'web.tree.table.controller'
      },
      {
        align: 'center',
        dataIndex: 'role_type',
        key: 'manager',
        render: (role_type: RoleType, row: any) => {
          return (
            <CSS.ContainerCheckbox>
              <Checkbox
                checked={role_type?.includes('MANAGER')}
                onChange={e => {
                  const role: SendRoleProps = {
                    assign_tree_id: isModal
                      ? treesSelected.id
                      : row.assign_tree_id,
                    role_type: RoleType.MANAGER,
                    user_id: row.user_id
                  }

                  if (e.target.checked) {
                    sendRole(role)
                    return
                  }
                  sendRole(Object.assign(role, { remove: true }))
                }}
              />
            </CSS.ContainerCheckbox>
          )
        },
        title: 'web.tree.table.manager'
      }
    ]

  return (
    <>
      {!isModal && (
        <CSS.StyledContent>
          <CSS.Container>
            <Text>{t('web.user.title')}</Text>
            <Button onClick={() => setVisibleModal(true)}>
              {t('common.actions.add')}
            </Button>
          </CSS.Container>
          <Divider style={{ margin: '0px' }} />
          <StatusFilter
            defaultValue={filterRole}
            onChange={e => {
              setFilterRole(e)
            }}
            options={['approver', 'checker', 'controller', 'manager']}
          />
        </CSS.StyledContent>
      )}
      <CSS.StyledContent>
        <CSS.StyledContentArea>
          <Table
            {...props}
            className="table-striped"
            columns={columns}
            size="small"
          />
        </CSS.StyledContentArea>
      </CSS.StyledContent>
    </>
  )
}
